import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <LanguageProvider>
      <div
        className="App bg-[#0A0A0A] text-white min-h-screen font-body"
        data-testid="app-root"
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#FFFFFF",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
